import React from 'react'

interface TestDeviceIconProps {
  size?: 'sm' | 'md' | 'lg' | 'xl'
  className?: string
}

export const TestDeviceIcon: React.FC<TestDeviceIconProps> = ({
  size = 'md',
  className = ''
}) => {
  const sizeClasses = {
    sm: 'w-3 h-3',
    md: 'w-4 h-4',
    lg: 'w-6 h-6',
    xl: 'w-8 h-8'
  }

  return (
    <svg
      className={`${sizeClasses[size]} text-highlight-green ${className}`}
      viewBox="0 0 24 24"
      fill="currentColor"
      aria-label="Test Device"
    >
      <path d="M7 2v2h1v14a4 4 0 0 0 8 0V4h1V2H7zm4 14c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm2-4c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm1-5H9V4h5v3z" />
    </svg>
  )
}
